<template>
	<b-container fluid class="signinForm">
		<b-row>
			<b-col md="12">
				<div class="sign">
				<div class="logo"></div>
				
					<b-form @submit="onSubmit" @reset="onReset" v-if="show&&showLoginForm">
						<h3 class="text-center">{{ $t("signin.head") }}</h3>
						<div class="welform">
							<div v-if="resetPasswordSent">
								<hr/>
								<div class="successAlert">
								<svg-image image="iconEnvelope"/>
								<h6 class="text-center">{{ $t("signin.alert.sent.label") }}</h6>
								<p class="text-center">{{ $t("signin.alert.sent.desc") }}</p>
								</div>
							</div>
							<div v-if="resetSuccess">
								<hr/>
								<div class="successAlert">
								<svg-image image="iconKey"/>
								<h6 class="text-center">{{ $t("signin.alert.reset.label") }}</h6>
								<p class="text-center">{{ $t("signin.alert.reset.desc") }}</p>
								</div>
							</div>
							<div v-if="success">
								<hr/>
								<div class="successAlert">
								<svg-image image="iconCheck"/>
								<h6 class="text-center">{{ $t("signin.alert.complete.label") }}</h6>
								<p class="text-center">{{ $t("signin.alert.complete.desc") }}</p>
								</div>
								<hr/>
							</div>
						</div>	

						<div v-if="!resetPasswordSent">
							<b-form-group id="email-group"
								:label="$t('signin.form.email')"
								label-for="email"
							>
								<b-form-input
									id="email"
									v-model="form.email"
									type="email"
									required
									:state="validation"
								></b-form-input>
								<b-form-invalid-feedback :state="validation">
									{{ $t("signin.form.emailmsg") }}
								</b-form-invalid-feedback>
							</b-form-group>

							<b-form-group id="password-group" class="password"
								:label="$t('signin.form.pwd')"
								label-for="password"
								v-if="!resetPasswordRequest"
							>
								<b-form-input
									id="password"
									v-model="form.password"
									type="password"
									required
									:state="validation"
								></b-form-input>
								<b-form-invalid-feedback :state="validation">
									<div><a href="" @click.prevent="resetPassword">{{$t('signin.form.pwdmsg')}}</a></div>
								</b-form-invalid-feedback>
							</b-form-group>
							<a v-if="!resetPasswordRequest&&validation==undefined" class="resetBtn" type="reset" @click.prevent="forgotPassword">{{$t('signin.form.resetbtn')}}</a>
							<alert :status="status"/>

							<div class="clearfix" style="margin-top:1em">						
								<!--<b-button to="/signup" class="float-left mr-2" type="signup" variant="warning">Don't Have Account ?</b-button>-->
								<b-button v-if="resetPasswordRequest" squared block variant="outline-primary" size="lg" :disabled="loading" @click.prevent="resetPassword"><b-spinner v-if="loading" small type="grow"></b-spinner> {{ $t("signin.form.pwdmsg") }}</b-button>
								<b-button v-if="!resetPasswordRequest" squared block variant="outline-primary" type="submit" size="lg" :disabled="loading"><b-spinner v-if="loading" small type="grow"></b-spinner> {{ $t("signin.btn") }}</b-button>
								<!-- <div class="separator"><p class="center-line"><span>or</span></p></div> -->
								

								<div v-html="$t('signin.agree')"></div>
								
								<div class="cta-register text-center"><a href="/signin/admin" class="textlink">Admin Console</a></div>
							</div>
						</div>

					</b-form>
					<b-form @submit="onReestPassword" @reset="onReset" v-if="show&&showResetForm">

						<h3 class="text-center mb-4">{{ $t("signin.reset.head") }}</h3>

						<b-form-group id="password-group"
							label-for="password"
						>
							<b-input-group>
								<b-form-input
									id="password"
									v-model="form.password"
									:class='{valid:passwordValidation.valid}' 
									:type="passwordVisible ? 'text' : 'password'"
									required
									:placeholder="$t('signin.reset.place1')"
									:state="passwordChecker"
								></b-form-input>
								<b-input-group-append>
									<b-button class="hideandseek" variant="info" @click='togglePasswordVisibility' :arial-label='passwordVisible ? "Hide password" : "Show password"'><b-icon :icon='passwordVisible ? "eye-slash-fill" : "eye-fill"'></b-icon></b-button>
								</b-input-group-append>			
							</b-input-group>				
							<b-form-input
								id="checkPassword"
								v-model.lazy='form.confirmPassword'
								type="password"
								required
								:placeholder="$t('signin.reset.place2')"
								:state="passwordChecker"
								class="mt-2"
							></b-form-input>
							<alert :status="status"/>
							<b-form-invalid-feedback :state="passwordChecker">
								<ul>
									<li v-for='error in passwordValidation.errors'>{{error}}</li>
									<li v-if="notSamePasswords">{{ $t("signin.reset.errmsg5") }}</li>
								</ul>
							</b-form-invalid-feedback>
							<b-form-valid-feedback :state="passwordChecker">
							</b-form-valid-feedback>
						</b-form-group>

						<div class="clearfix mb-4">						
							<b-button squared block variant="outline-primary" type="submit" size="lg" :disabled="loading"><b-spinner v-if="loading" small type="grow"></b-spinner> {{ $t("signin.reset.btn") }}</b-button>
							<div v-html="$t('signin.agree')"></div>
						</div>

					</b-form>
					<!-- <b-card class="mt-3" header="Form Data Result">
						<pre class="m-0">{{ form }}</pre>
					</b-card> -->
				</div>
			</b-col>
			<div class="overlapButton" v-if="show&&showLoginForm">
				<b-button squared block variant="primary" to="/signup" size="lg">{{ $t("signin.reg") }}</b-button>
			</div>
		</b-row>
	</b-container>
</template>

<script>
	import SvgImage from '../components/SvgImage.vue';
   	import Alert from '../components/Alert.vue';
	export default {
		data() {
			return {
				form: {
					email: '',
					password: '',
					confirmPassword: '',
					// name: '',
					// food: null,
					// checked: []
				},
				success : false,
				validation : null,
				showLoginForm: true,
				showResetForm: false,
				// foods: [{ text: 'Select One', value: null }, 'Carrots', 'Beans', 'Tomatoes', 'Corn'],
				loading: false,
				show: true,
				status: null,
				passwordVisible:false,
				checkPassword:'',
				rules: [
					{ message:"One lowercase letter required", regex:/[a-z]+/ },
					{ message:"One uppercase letter required",  regex:/[A-Z]+/ },
					{ message:"8 characters minimum", regex:/.{8,}/ },
					{ message:"One number required", regex:/[0-9]+/ }
				],
				resetSuccess : false,
				resetPasswordSent : false,
				resetPasswordRequest : false
			}
		},
		components : {
			Alert,
			SvgImage,
		},
		mounted(){
			if (this.$router.currentRoute.query&&this.$router.currentRoute.query.success){
				this.success = true;
				// console.log('AAAAA', this.$router.currentRoute);
			}
			this.init();
		},
		computed:{
			resetPasswords () {
				this.form.password = ''
				this.form.confirmPassword = ''
			},
			passwordChecker(){
				if (this.form.password){
					if (this.passwordsFilled&&this.passwordValidation.valid&&!this.notSamePasswords){
						return true
					} else {
						return false
					}
					// return !this.notSamePasswords
				}
			},
			notSamePasswords () {
				if (this.passwordsFilled) {
					return (this.form.password !== this.form.confirmPassword)
				} else {
					return false
				}
			},
			passwordsFilled () {
				return (this.form.password !== '' && this.form.confirmPassword !== '')
			},
			passwordValidation () {
				let errors = []
				for (let condition of this.rules) {
					if (!condition.regex.test(this.form.password)) {
						errors.push(condition.message)
					}
				}
				if (errors.length === 0) {
					return { valid:true, errors }
				} else {
					return { valid:false, errors }
				}
			}
		},
		methods: {
			init(){
				if (this.$router.currentRoute.params&&this.$router.currentRoute.params.action){
					switch(this.$router.currentRoute.params.action) {
						case 'reset':
							this.showLoginForm = false;
							this.showResetForm = true;
							// this.showOtp = true;
							// this.showForm = false;
							// if (this.$router.currentRoute.query){
							// 	this.formOtp.otpCode = this.$router.currentRoute.query.code;
							// 	this.onOtp();
							// }
							// code block
						break;
						case 'resetPasswordRequest':
							this.resetPasswordRequest = true;
						break;

						case 'admin':
							this.userType = 'admin';
						break;
						default:
							this.showLoginForm = true;
							// code block
					}				
					// console.log(this.$router.currentRoute.params, this.$router.currentRoute.query);
				} else {
					this.showForm = true;
				}
			},
			togglePasswordVisibility () {
				this.passwordVisible = !this.passwordVisible
			},
			mounted(){
				// this.$store.dispatch('login', { email, password })
			},
			onReestPassword(evt){
				this.loading = true;
				evt.preventDefault()
				var id = this.$router.currentRoute.query.code + '/' + this.$router.currentRoute.query.key;
				this.$store.dispatch('CHANGEPASSWORD', {params:{id:id}, data:this.form})
					.then(o=>{
						this.loading = false;
						this.resetSuccess = true;
						this.showLoginForm = true;
						this.showResetForm = false;
					})
					.catch(err=>{
						this.loading = false;
						console.log('Sumthing wrung... ', err);
						if (err.response){
							this.status = err.response;
						}
					})
				console.log('Do reset... ', this.form, id);
			},
			onSubmit(evt) {
				this.loading = true;
				evt.preventDefault()
				console.log('Do login... ', this.form);
				this.$store.dispatch('SIGNIN', {data:this.form, userType: this.userType})
					.then((loginOut) =>{
						this.loading = false;
						console.log('AAAA : ', loginOut)
						if (this.userType=='admin'){
							this.$router.push('/list')
						} else {
							this.$router.push('/')
						}
					})
					.catch(err => {
						this.loading = false;
						if (err.response){							
							this.validation = false;
							this.status = err.response;
						} else {
							alert("Network disconnected, please check your internet connection.");
						}
					})
			},
			onReset(evt) {
				evt.preventDefault()
				// Reset our form values
			},
			resetPassword(){
				// console.log(this.form)
				this.$store.dispatch('RESETPASSWORD', {data:{email:this.form.email}})
					.then((resetOut) =>{
						this.loading = false;
						this.resetPasswordSent = true;
					})
					.catch(err => {
						this.loading = false;
						this.validation = false;
						if (err.response){
							this.status = err.response;
						}
					})
				// RESETPASSWORD
			},
			forgotPassword(){
				this.resetPasswordRequest = true;
				// this.$router.push({params: { action: 'resetPasswordRequest' }})
			}
		}
	}
</script>


// WEBPACK FOOTER //
// SigninView.vue